function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
  id: "pets_sm_svg__a",
  d: "M0 0h26v26H0z"
}));

var _ref2 = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", {
  transform: "translate(1 1)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M14.5 6.174a3.094 3.094 0 003.096 3.093 3.094 3.094 0 003.096-3.093A3.094 3.094 0 0017.934 3.1c-.074-.008-.728.376-1.961 1.152L14.5 6.174z",
  fill: "#FFB74D"
}), /*#__PURE__*/React.createElement("g", {
  transform: "translate(0 11)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M17.836 13.543c-1.193-1.07-1.438-.543-2.732-1.219-1.982-1.034-3.352-2.326-4.112-3.876.106-.356.165-.721.165-1.088a4.849 4.849 0 00-2.405-4.192C8.114 2.156 6.834.607 6.163.362c-.671-.245-.295 1.15-.619 2.21a4.85 4.85 0 00-4.06 4.509 5.52 5.52 0 00-1.175.984c-.19.222-.309.394-.309.874 0 1.445 1.41 2.414 3.685 2.463.25.005.462 0 .64-.017.393.23.79.419 1.16.563-.235.686-.495.823-.56 1.543-.04.467 1.229-.046 3.737-.061.647-.004 2.573-.034 3.397.091 3.859.588 6.162.367 5.777.022z",
  fill: "#FFB74D"
}), /*#__PURE__*/React.createElement("path", {
  d: "M18.175 13.197c-1.087-.483-2.141-.904-3.071-1.37-1.982-.991-3.352-2.23-4.112-3.716.106-.34.165-.69.165-1.042 0-1.715-.966-3.213-2.405-4.019C8.114 2.08 6.834.595 6.163.36c-.671-.234-.295 1.103-.619 2.12-1.832.281-3.32 1.551-3.855 3.222-.112.35-.183.719-.205 1.1-.52.31-.966.707-1.175.942-.19.214-.309.378-.309.838 0 1.386 1.41 2.314 3.685 2.361.25.006.462 0 .64-.016.393.22.79.401 1.16.54-.323.9-.464 1.36-.487 2.315",
  stroke: "#371447",
  strokeWidth: 1.038
}), /*#__PURE__*/React.createElement("circle", {
  fill: "#371447",
  cx: 3.75,
  cy: 6.746,
  r: 1
}), /*#__PURE__*/React.createElement("path", {
  d: "M.527 9.5c.332 0 .973-.478.973-.865C1.5 8.247.932 8 .6 8c-.331 0-.6.314-.6.702 0 .388.195.798.527.798z",
  fill: "#371447"
})), /*#__PURE__*/React.createElement("path", {
  d: "M4.99 22.302c1.663-1.187 4.3-2.804 6.61-3.213 6.012-1.065 7.703-3.695 5.072-7.888-.3-.143-.58-.311-.84-.502-3.172.019-4.87-.05-5.092-.204-2.89-1.37-2.122-4.276-1.631-4.498.982-.492 2.772-.671 5.368-.537.796-1.535 2.559-2.601 4.604-2.601.309 0 .61.024.903.07.855-1.536.748-2.284.887-2.84.147-.59 2.886 1.857 2.033 4.303.769.779 1.234 1.795 1.234 2.906 0 .229-.02.453-.058.673l.257 3.258L24.5 14",
  stroke: "#371447",
  strokeWidth: 1.038
}), /*#__PURE__*/React.createElement("circle", {
  fill: "#371447",
  cx: 16.75,
  cy: 6.75,
  r: 1
}), /*#__PURE__*/React.createElement("path", {
  d: "M8.883 7.5c.555 0 1.63-.796 1.63-1.442C10.512 5.412 9.56 5 9.005 5 8.45 5 8 5.524 8 6.17c0 .646.327 1.33.883 1.33z",
  fill: "#371447"
})));

function SvgPetsSm(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _ref, _ref2);
}

export default SvgPetsSm;